import { customerFeatureStateSlice } from '@features/customer';
import { defaultState as defaultAccessoriesState } from '@features/accessories/default-state';
import { defaultState as defaultCommentsState } from '@features/comments/default-state';
import { defaultState as defaultDebugState } from '@features/debug/default-state';
import { defaultState as defaultLayerState } from '@features/layer/default-state';
import { defaultState as defaultNavigationState } from '@features/navigation/default-state';
import { defaultState as defaultPromotionalSkuState } from '@features/promotional-sku/default-state';
import { defaultState as defaultValidationState } from '@features/validation/default-state';
import { defaultState as defaultViewModeState } from '@features/view/default-state';


import { State } from './state.type';

export const stateInitializer = (): State => {
	return {
		accessories: defaultAccessoriesState,
		comments: defaultCommentsState,
		customer: customerFeatureStateSlice.initialState,
		debug: defaultDebugState,
		layer: defaultLayerState,
		navigation: defaultNavigationState,
		validation: defaultValidationState,
		viewMode: defaultViewModeState,
		promotionalSku: defaultPromotionalSkuState
	};
};
